/**
 * Supported TwinCAT file extensions
 */
export const TWINCAT_EXTENSIONS = ['.TcPOU', '.TcGVL', '.TcDUT', '.TcTLEO', '.TcIO', '.tmc'];

/**
 * Check if a file path has a TwinCAT extension
 * @param {string} filePath - The file path to check
 * @returns {boolean} - True if file has TwinCAT extension
 */
export const isTwinCATFile = (filePath) => {
  return TWINCAT_EXTENSIONS.some(ext => 
    filePath.toLowerCase().endsWith(ext.toLowerCase())
  );
};
